export enum ExceptionDetailsProperties {
    timestamp = 'Exception Time',
    outerMessage = 'Outer Message',
    innermostMessage = 'Inner Most Message',
    OuterMethod = 'Outer Method',
    OuterType = 'Outer Type',
    roleInstance = 'Role Instance',
}
